import {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { apiUrls } from "constants/apiUrls";
import { AppState } from "slice";
import { baseQuery } from "./baseQuery";

type Error = {
    message: string;
    error?: string;
};

const checkForImageApi = (args: FetchArgs) => {
    if (args.url.includes("user_images")) {
        return true;
    } else if (args.body instanceof FormData) {
        return true;
    } else return false;
};

export const baseQueryWithReAuth: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const isImageApi = checkForImageApi(args as FetchArgs);
    let result = await baseQuery(isImageApi)(args, api, extraOptions);
    const state: AppState = api.getState() as AppState;
    if (
        api.endpoint !== "login" &&
        result.error &&
        result.error.status === 401
    ) {
        const refreshTokenApiResult: any = await baseQuery()(
            {
                url: apiUrls.loginOrRefresh,
                method: "POST",
                body: {
                    refresh_token: state.userAuth.refresh_token,
                    grant_type: "refresh_token",
                },
            },
            api,
            extraOptions
        );
        if (refreshTokenApiResult.data) {
            localStorage.setItem(
                "userAuth",
                JSON.stringify({
                    ...refreshTokenApiResult.data,
                    fromRefreshToken: true,
                })
            );
            result = await baseQuery(isImageApi)(args, api, extraOptions);
        } else {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("userAuth");
            window.location.reload();
        }
    }
    if (
        api.endpoint !== "login" &&
        result.error &&
        result.error.status === 422 &&
        (result.error.data as Error).error?.includes("Invalid token")
    ) {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("userAuth");
        window.location.reload();
    }

    if (result.error && result.error.status === 403) {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("userAuth");
        window.location.reload();
    }
    return result;
};
